
import React from 'react';
import { Button } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import moment from 'moment';
import secondStepConstanst from '../assets/items.json'
// import DeParamMovingURL from '../common/DeParamMovingURL.js';

class ThirdStep extends React.Component {
  constructor(props) {
    super(props);

    // Setup save/read top component state
    this.saveTopState = props.saveTopState;
    this.readTopState = props.readTopState;

    // Reading state parameters from top state
    let savedFirstState = this.readTopState('firstStepState');
    let savedSecondState = this.readTopState('secondStepState');
    let savedThirdState = this.readTopState('thirdStepState');

    this.state = {
      firstStepState: savedFirstState.movingFromAddress ? savedFirstState : {
        "movingFromAddress": { "value": { "lat": 28.8240644, "lng": -81.3185346 }, "label": "Manhattan, New York, NY, USA", "isValid": true, "cityAndState": { "city": "New York", "state": "NY" } }, "movingToAddress": { "value": { "lat": 31.05679419999999, "lng": -89.18937199999999 }, "label": "Brooklyn, MS 39425, USA", "isValid": true, "cityAndState": { "city": "Brooklyn", "state": "MS" } }, "movingTypeFrom": { "value": "1", "label": "Studio" }, "movingFromFlights": { "value": "2", "label": "2nd floor walk up" }, "movingToFlights": { "value": "0", "label": "Ground floor" }, "moveSize": { "value": "1", "label": "Studio or Partial Apartment" }, "movingDate": "2018-11-24", "errorclass": "before-error-validation", "distance": 9, "isValid": false
      },
      secondStepState: savedSecondState.packingOption ? savedSecondState : {
        "items": { "Living Room": { "name": "Living Room", "elements": { "TV flat 21''-42''": { "name": "TV flat 21''-42''", "quantity": 4, "volume": 10 } } } }, "totalVolume": 40, "customItems": {}, "customItemIndex": 0, "packingOption": { "value": "1", "label": "Option 1 - Economy" }, "storageAcOption": { "value": "1", "label": "A/C Storage" }, "storageDuration": { "value": "1", "label": "1 Month" }, "referrence": { "value": "2", "label": "Used DUMBO before / Repeat Customer" }, "volumeErrorMsg": "hide-error-msg", "customItemsErrorMsg": "hide-error-msg"

      },
      moveDetails: { prices: {} },
      theitems: savedThirdState.itemsformail,
      prices: {},
      datePrices: {},
      binsNumber: savedThirdState.binsNumber,
      wardrobeNumber: savedThirdState.wardrobeNumber,
      numOfMen: savedThirdState.numOfMen,
      typeOfStructure: savedThirdState.typeOfStructure,
      boxes: savedThirdState.boxes,
      cfWboxes: savedThirdState.cfWboxes,
      storageType: savedThirdState.storageType,
      storagePrice: savedThirdState.storagePrice,
      storageMonths: savedThirdState.storageMonths,
      flightTime: savedThirdState.flightTime,
      movingTime: savedThirdState.movingTime,
      travelTime: savedThirdState.travelTime,
      totalTime: savedThirdState.totalTime,
      hourlyRatesDaily: savedThirdState.hourlyRatesDaily,
      yourName: savedThirdState.yourName ? savedThirdState.yourName : { isFieldValid: false },
      yourLastName: savedThirdState.yourLastName ? savedThirdState.yourLastName : { isFieldValid: false },
      yourEmail: savedThirdState.yourEmail ? savedThirdState.yourEmail : { isFieldValid: false },
      yourPhone: savedThirdState.yourPhone ? savedThirdState.yourPhone : { isFieldValid: false },
      newDate: savedThirdState.newDate ? savedThirdState.newDate : this.readTopState('firstStepState').movingDate,
      errorclass: "",
      noDoubleSubmit: false,
      distance: savedThirdState.distance ? savedThirdState.distance : 0
    };

    // Binding methods
    this.changePacking = this.changePacking.bind(this);
    this.changeDate = this.changeDate.bind(this);
    this.changePackingOption = this.changePackingOption.bind(this);
    this.NewlineText = this.NewlineText.bind(this);
    this.onInputFieldChange = this.onInputFieldChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBack = this.handleBack.bind(this);
  }


  NewlineText() {
    let secondStepState = this.state.secondStepState;
    let theobject = secondStepState['items'];
    console.log(theobject)
    return (<ul className="theitems">

      {Object.keys(theobject).map((theroom) => {
        return (
          <li><strong>{theobject[theroom].name}</strong>:&nbsp;
            {theobject[theroom].name !== 'Custom Items' ?
              Object.keys(theobject[theroom]).map((theitems) => {
                return (
                  <span>
                    {Object.keys(theobject[theroom][theitems]).map((theitem) => {
                      if (theobject[theroom][theitems][theitem].name) {
                        return <span>{theobject[theroom][theitems][theitem].name} x {theobject[theroom][theitems][theitem].quantity}, </span>
                      }
                    })
                    }
                  </span>
                )
              }) :
              Object.keys(theobject[theroom]).map((theitems) => {
                return (
                  <span>
                    {Object.keys(theobject[theroom][theitems]).map((theitem) => {
                      if (theobject[theroom][theitems][theitem].name) {
                        return <span>{theobject[theroom][theitems][theitem].name} ({theobject[theroom][theitems][theitem].lenght}cm x {theobject[theroom][theitems][theitem].width}cm x {theobject[theroom][theitems][theitem].height}cm) x {theobject[theroom][theitems][theitem].quantity}, </span>
                      }
                    })
                    }
                  </span>
                )
              }
              )
            }
          </li>
        )
      })
      }
    </ul>
    )
  }

  /**
   * On component mount send data to server and get calculated price
   * @return {[type]} [description]
   */
  componentDidMount() {

    // this.getItems();
    // Combine all relevant state data into one object
    let firstStepState = this.state.firstStepState;
    let secondStepState = this.state.secondStepState;

    let newDate = new Date(this.state.firstStepState.movingDate);
    let fullNewDate = newDate.getDate() + "-" + ("0" + (newDate.getMonth() + 1)).slice(-2) + "-" + newDate.getFullYear()

    var convertDate = new Date(newDate);
    var selectedDay = convertDate.getDay();

    let wardrobeNumber = 0;
    let binsNumber = 0;

    let theobject = secondStepState['items'];

    console.log(this.state, 'thirdstate');

    let tryRooms = [];
    let itemsformail = "";

    for (let key in theobject) {
      if (!tryRooms.includes(theobject[key].name)) {
        tryRooms.push(theobject[key].name);
        itemsformail += "|" + theobject[key].name + ": ]";
      }
      if (theobject[key].name === "Custom Items") {
        for (let obj in theobject[key]) {
          let newobj = theobject[key][obj];
          for (let objitem in newobj) {
            if (newobj[objitem].name) {
              itemsformail += newobj[objitem].name + '(' + newobj[objitem].lenght + 'cm x ' + newobj[objitem].width + 'cm x ' + newobj[objitem].height + 'cm)' + ' x ' + newobj[objitem].quantity + ', ';
            }
          }
        }
      } else {
        for (let obj in theobject[key]) {
          let newobj = theobject[key][obj];
          for (let objitem in newobj) {
            if (newobj[objitem].name) {
              itemsformail += newobj[objitem].name + ' x ' + newobj[objitem].quantity + ', ';
            }
          }
        }
      }
    }
    console.log(itemsformail)
    let userInput = {
      'wardrobeNumber': wardrobeNumber,
      'binsNumber': binsNumber,
      'cityStateFrom': firstStepState['movingFromAddress']['cityAndState'],
      'cityFrom': firstStepState['movingFromAddress']['cityAndState']['city'],
      'postalFrom': firstStepState['movingFromAddress']['searchFromPostalCode'],
      'streetAddressFrom': firstStepState['movingFromAddress']['streetAddress'],
      'cityStateTo': firstStepState['movingToAddress']['cityAndState'],
      'cityTo': firstStepState['movingToAddress']['cityAndState']['city'],
      'postalTo': firstStepState['movingToAddress']['searchToPostalCode'],
      'streetAddressTo': firstStepState['movingToAddress']['streetAddress'],
      'date': firstStepState['movingDate'],
      'directDistance': firstStepState['pickupToDelivery']['distance'],
      'longestDistance': firstStepState['longestDistance'],
      'pickupState': firstStepState['pickupState'],
      'deliveryState': firstStepState['deliveryState'],
      'baseToDelivery': firstStepState['baseToDelivery']['distance'],
      'baseToPickup': firstStepState['baseToPickup']['distance'],
      'travelDuration': firstStepState['travelDuration'],
      'floorFrom': firstStepState['movingFromFlights'].value,
      'floorTo': firstStepState['movingToFlights'].value,
      'typeOfStructure': firstStepState['movingTypeFrom'].value,
      'storageType': secondStepState['storageAcOption'].value,
      'frontCf': secondStepState['totalVolume'],
      'packaging': secondStepState['packingOption'].label,
      'storageAcOption': secondStepState['storageAcOption'].label,
      'storageDuration': secondStepState['storageDuration'].label,
      'storageMonths': secondStepState['storageDuration'].value,
      'travelDurationBP': firstStepState['travelDurationBP'],
      'travelDurationDB': firstStepState['travelDurationDB'],
      'travelDurationPD': firstStepState['travelDurationPD'],
      'moveTypeFrom': firstStepState['movingFromElevator'].label,
      'moveTypeTo': firstStepState['movingToElevator'].label,
      'referrence': {
        'name': secondStepState['referrence'].label,
        'type': secondStepState['referrence'].value,
      },
    }


    //Send combined data to the server for calculation
    fetch('/wp-json/qc/v1/calculate', {
      method: 'POST',
      headers: {
        'Accept': 'application/json; charset=UTF-8',
        'Content-Type': 'application/json; charset=UTF-8',
      },
      body: JSON.stringify({
        "user_input": JSON.stringify(userInput)
      })
    })
      .then(res => res.json())
      .then(
        (result) => {

          //Prepare output for state
          let moveDetails = JSON.parse(result);
          console.log(moveDetails);
          // Get all pricess
          let prices = JSON.parse(moveDetails.prices);
          //  let totalDistance = JSON.parse(moveDetails.$totalDistance);
          let distance = JSON.parse(moveDetails.$distance);
          let numOfMen = JSON.parse(moveDetails.number_of_workers);
          let typeOfStructure = JSON.parse(moveDetails.type_of_structure);
          let boxes = JSON.parse(moveDetails.boxes);
          let cfWboxes = JSON.parse(moveDetails.cf);
          let storageType = JSON.parse(moveDetails.storage_type);
          let storagePrice = JSON.parse(moveDetails.storage_price);
          let storageMonths = JSON.parse(moveDetails.storage_months);
          let flightTime = JSON.parse(moveDetails.flights_time_addition_total);
          let movingTime = JSON.parse(moveDetails.$moving_time);
          let travelTime = JSON.parse(moveDetails.$total_travel_time);
          let hourlyRatesDaily = JSON.parse(moveDetails.hour_rate);
          let totalTime = JSON.parse(moveDetails.$total_all_time);

          // Get prices for different packing options for selected move date
          let datePrices = (prices[this.state.firstStepState.movingDate] !== undefined) ? prices[this.state.firstStepState.movingDate] : (prices[this.state.firstStepState.movingDate] === "TBD") ? prices[this.state.firstStepState.movingDate] : { 1: "Selected date is not available, please choose another one", 2: "Selected date is not available, please choose another one" };

          console.log("prices", prices);
          console.log("datePrices", datePrices);

          // Price for every move type
          let basicPrice = Object.values(datePrices)[0];
          let economyPrice = Object.values(datePrices)[1];
          let standardPrice = Object.values(datePrices)[2];
          let premiumPrice = Object.values(datePrices)[3];

          // Get price for date and selected packing option
          let datePackingPrice = (datePrices !== undefined) ? datePrices[this.state.secondStepState.packingOption.value] : "TBD";

          if ((datePackingPrice != 'TBD') && (selectedDay > 4 || selectedDay == 0)) {
            datePackingPrice = ((datePrices[this.state.secondStepState.packingOption.value]) * 1.05).toFixed(2);
            basicPrice = (basicPrice * 1.05).toFixed(2);
            economyPrice = (economyPrice * 1.05).toFixed(2);
            standardPrice = (standardPrice * 1.05).toFixed(2);
            premiumPrice = (premiumPrice * 1.05).toFixed(2);

            this.setState({
              datePackingPrice: datePackingPrice,
              basicPrice: basicPrice,
              economyPrice: economyPrice,
              standardPrice: standardPrice,
              premiumPrice: premiumPrice
            })
          } else {
            console.log('Not Weekend')
          }

          this.setState({
            isLoaded: true,
            //  totalDistance: totalDistance,
            distance: distance,
            moveDetails: moveDetails,
            datePrices: datePrices,
            datePackingPrice: datePackingPrice,
            basicPrice: basicPrice,
            economyPrice: economyPrice,
            standardPrice: standardPrice,
            premiumPrice: premiumPrice,
            prices: prices,
            theitems: itemsformail,
            binsNumber: binsNumber,
            wardrobeNumber: wardrobeNumber,
            numOfMen: numOfMen,
            typeOfStructure: typeOfStructure,
            boxes: boxes,
            cfWboxes: cfWboxes,
            storageType: storageType,
            storagePrice: storagePrice,
            storageMonths: storageMonths,
            flightTime: flightTime,
            movingTime: movingTime,
            travelTime: travelTime,
            totalTime: totalTime,
            hourlyRatesDaily: hourlyRatesDaily,
            newDate: fullNewDate
          }, () => { console.log('dateeepr', this.state.datePrices) });
        },

        (error) => {
          this.setState({
            isLoaded: true,
            error
          }, () => console.log(error));
        }
      );

  }



  /**
    * Method for getting the items for front view
    * @param  {[type]} option [description]
    * @param  {[type]} event  [description]
    * @return {[type]}        [description]
    */
  changePacking(option, event) {

    event.preventDefault();

    let firstStepState = this.state.firstStepState;
    // Set variables for secondStepState and
    let secondStepState = this.state.secondStepState;
    let newPackingLabel = '';


    // Define label based on selected option
    switch (parseInt(option, 10)) {
      case (1):
        newPackingLabel = '1. Basic Move';
        break;
      case (2):
        newPackingLabel = '2. Economy Move';
        break;
      case (3):
        newPackingLabel = '3. Standard Move';
        break;
      case (4):
        newPackingLabel = '4. Premium Move';
        break;
      default:
        console.log('no cases');
        break;
    }


    // Prepare values for saving in state
    secondStepState.packingOption.value = parseInt(option, 10);
    secondStepState.packingOption.label = newPackingLabel;
    let datePackingPrice = this.state.prices[firstStepState.movingDate][parseInt(option, 10)];
    // Save new values to state
    this.setState({
      secondStepState: secondStepState,
      datePackingPrice: datePackingPrice,
      newPackingLabel: newPackingLabel
    }, () => console.log(this.state.datePackingPrice))

  }


  /**
   * Method for changing date and saving current price based on new date
   * @param  {[type]} date  [description]
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  changeDate(date, event) {
    event.preventDefault();

    // Prepare variables
    let datePackingPrice = this.state.prices[date][this.state.secondStepState.packingOption.value];
    let datePrices = this.state.datePrices;
    let basicPrice = Object.values(datePrices)[0];
    let economyPrice = Object.values(datePrices)[1];
    let standardPrice = Object.values(datePrices)[2];
    let premiumPrice = Object.values(datePrices)[3];

    let firstStepState = this.state.firstStepState;
    firstStepState.movingDate = date;

    var convertDate = new Date(date);
    var selectedDay = convertDate.getDay();
    console.log(this.state.secondStepState.packingOption.value, 'PACKING OPTION VALUE')

    if ((datePackingPrice != 'TBD') && (selectedDay > 4 || selectedDay == 0)) {
      datePackingPrice = ((this.state.prices[date][this.state.secondStepState.packingOption.value]) * 1.05).toFixed(2);
      basicPrice = (basicPrice * 1.05).toFixed(2);
      economyPrice = (economyPrice * 1.05).toFixed(2);
      standardPrice = (standardPrice * 1.05).toFixed(2);
      premiumPrice = (premiumPrice * 1.05).toFixed(2);

      this.setState({
        datePackingPrice: datePackingPrice,
        firstStepState: firstStepState,
        basicPrice: basicPrice,
        economyPrice: economyPrice,
        standardPrice: standardPrice,
        premiumPrice: premiumPrice
      })
    } else {
      datePackingPrice = this.state.prices[date][this.state.secondStepState.packingOption.value];

      this.setState({
        datePackingPrice: datePackingPrice,
        firstStepState: firstStepState,
        basicPrice: basicPrice,
        economyPrice: economyPrice,
        standardPrice: standardPrice,
        premiumPrice: premiumPrice
      })
    }
    // Saving variables

  }

  /**
   * Method for changing date and saving current price based on new date
   * @param  {[type]} date  [description]
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  changePackingOption(event) {
    event.preventDefault();
    let { type } = event.target;

    //Change Packing Option
    let secondStepState = this.state.secondStepState;
    secondStepState.packingOption.label = event.target.name;
    secondStepState.packingOption.value = event.target.id;

    let datePrices = this.state.datePrices;
    let datePackingPrice = this.state.datePackingPrice;

    var convertDate = new Date(this.state.firstStepState.movingDate);
    var selectedDay = convertDate.getDay();

    //Change Price - 5%+ on the weekends
    if (selectedDay > 4 || selectedDay == 0) {
      datePackingPrice = (Object.values(datePrices)[event.target.id - 1] * 1.05).toFixed(2);
    } else {
      datePackingPrice = Object.values(datePrices)[event.target.id - 1];
    }

    this.setState({
      packaging: event.target.name,
      packingValue: event.target.id,
      datePackingPrice: datePackingPrice,
      secondStepState: secondStepState
    })
  }


  /**
   * Method for validating and saving input fields
   * @param  {[type]} event input field that is changing
   * @return {[type]}       adding or removing error class
   */
  onInputFieldChange(event) {

    // Prepare variables
    let { name, value } = event.target;
    let isFieldValid = false;

    // Creating validation cases
    switch (name) {
      case 'yourName':
        isFieldValid = (value.length > 2) ? true : false;
        break;
      case 'yourLastName':
        isFieldValid = (value.length > 2) ? true : false;
        break;
      case 'yourEmail':
        isFieldValid = (value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) ? true : false;
        break;
      case 'yourPhone':
        isFieldValid = (value.match(/^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/)) ? true : false;
        break;
      default:
        console.log('no cases');
        break;
    }

    // Saving to state
    this.setState({
      [name]: {
        'value': value,
        'isFieldValid': isFieldValid
      },
    });
    event.target.className = (isFieldValid ? 'input-valid' : 'input-error');
  }


  /**
   * Going to previous step
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  handleBack(event) {

    event.preventDefault();
    const calcFormAnchor = (window.scrollY + document.getElementById('calcForm').getBoundingClientRect().top - 200);

    // Saving current state and going to previous step
    const activeStep = this.readTopState('activeStep');
    this.saveTopState({
      activeStep: activeStep - 1,
      thirdStepState: {
        yourName: this.state.yourName,
        yourLastName: this.state.yourLastName,
        yourEmail: this.state.yourEmail,
        yourPhone: this.state.yourPhone,
      },
      firstStepState: this.state.firstStepState,
      secondStepState: this.state.secondStepState,
    }, () => window.scrollTo(0, calcFormAnchor));

  }


  /**
   * Validating all fields and sending data to server if everything checks out
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  handleSubmit(event) {

    event.preventDefault();
    console.log('quick', this.state.datePrices)
    // If all fields from step 3 are valid
    if (this.state.yourName.isFieldValid && this.state.yourLastName.isFieldValid && this.state.yourEmail.isFieldValid && this.state.yourPhone.isFieldValid && this.state.noDoubleSubmit === false) {
      this.setState({
        noDoubleSubmit: true
      });
      document.getElementById('submit-loading').style.display = 'block';

      //Preparing variables to be used for sending
      let firstStepState = this.state.firstStepState;
      let secondStepState = this.state.secondStepState;

      //Send data to the server for getting quote and email sending
      fetch('/wp-json/qc/v1/quotes', {
        method: 'POST',
        headers: {
          // 'Accept': 'application/json; charset=UTF-8',
          'Content-Type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          addressFrom: firstStepState['movingFromAddress'].label,
          cityFrom: firstStepState['movingFromAddress']['cityAndState']['city'],
          postalFrom: firstStepState['movingFromAddress']['searchFromPostalCode'],
          streetAddressFrom: firstStepState['movingFromAddress']['streetAddress'],
          addressTo: firstStepState['movingToAddress'].label,
          cityTo: firstStepState['movingToAddress']['cityAndState']['city'],
          postalTo: firstStepState['movingToAddress']['searchToPostalCode'],
          streetAddressTo: firstStepState['movingToAddress']['streetAddress'],
          cf: secondStepState['totalVolume'],
          date: firstStepState['movingDate'],
          floorFrom: firstStepState['movingFromFlights'].label,
          floorTo: firstStepState['movingToFlights'].label,
          // typeOfStructure: firstStepState['movingTypeFrom'].label,
          movingFromElevator: firstStepState['movingFromElevator'].label,
          movingToElevator: firstStepState['movingToElevator'].label,
          moveHomeSizeFrom: firstStepState['movingHomeSizeFrom'].label,
          moveHomeSizeTo: firstStepState['movingHomeSizeTo'].label,
          moveTypeFrom: firstStepState['movingTypeFrom'].label,
          moveTypeTo: firstStepState['movingTypeTo'].label,
          packaging: secondStepState['packingOption'].label,
          storageAcOption: secondStepState['storageAcOption'].label,
          storageDuration: secondStepState['storageDuration'].label,
          price: this.state.datePackingPrice,
          basicPrice: this.state.basicPrice,
          economyPrice: this.state.economyPrice,
          standardPrice: this.state.standardPrice,
          premiumPrice: this.state.premiumPrice,
          directDistance: firstStepState['pickupToDelivery']['distance'],
          baseToPickup: firstStepState['baseToPickup'],
          baseToDelivery: firstStepState['baseToDelivery'],
          name: this.state.yourName.value,
          lastname: this.state.yourLastName.value,
          email: this.state.yourEmail.value,
          phone: this.state.yourPhone.value,
          allItemsForMoving: this.state.theitems,
          allItemsForMovingBr: this.state.theitems,
          referrence: secondStepState['referrence'].label,
          smallBinsNumber: this.state.binsNumber,
          mediumBinsNumber: this.state.binsNumber,
          largeBinsNumber: this.state.binsNumber,
          wardrobeBoxNumber: this.state.wardrobeNumber,
          longestDistance: firstStepState['longestDistance'],
          deliveryState: firstStepState['deliveryState'],
          pickupState: firstStepState['pickupState'],
          travelDuration: firstStepState['travelDuration'],
          additionalText: secondStepState['additionalText'],
          numOfMen: this.state.numOfMen,
          typeOfStructure: this.state.typeOfStructure,
          boxes: this.state.boxes,
          cfWboxes: this.state.cfWboxes,
          storageType: this.state.storageType,
          storagePrice: this.state.storagePrice,
          storageMonths: this.state.storageMonths,
          flightTime: this.state.flightTime,
          movingTime: this.state.movingTime,
          travelTime: this.state.travelTime,
          totalTime: this.state.totalTime,
          hourlyRatesDaily: this.state.hourlyRatesDaily,
          prices: this.state.datePrices
        })
      })
        .then(res => res.json())
        .then(
          (result) => {
            window.location = '/qc-thank-you/';
          },

          (error) => {

            console.log(error);
          }
        );

    }
    // If else throw an error class
    else {
      this.setState({
        errorclass: 'input-error'
      });
    }

  }

  render() {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var discountDays = ['Sunday', 'Friday', 'Saturday'];
    let datePrices = this.state.datePrices;

    var convertDate = new Date(this.state.firstStepState.movingDate);
    var selectedDay = convertDate.getDay();

    return (
      <div className="qc-third-step">
        <div className='qc-third-step-top'>
          <div className="md-quote-info">
            <p className="move-date"><strong>Date of Move:</strong> {this.state.newDate} </p>
            <p className="moving-from-address"><strong>Pickup Address:</strong> {this.state.firstStepState.movingFromAddress.label} </p>
            <p className="elevator-from"><strong>Moving From Floor:</strong> {this.state.firstStepState.movingFromFlights.label} </p>
            <p className="moving-to-address"><strong>Delivery address:</strong> {this.state.firstStepState.movingToAddress.label} </p>
            <p className="elevator-to"><strong>Moving to Floor:</strong> {this.state.firstStepState.movingToFlights.label} </p>
            <p className="elevator-to"><strong>CBM:</strong> {Math.round(this.state.cfWboxes * 1e4) / 1e4} cbm</p>
            <div className="elevator-to"><p><strong>Items for Moving: </strong></p>
              {this.NewlineText()}
            </div>

            <p className="packing-option"><strong>Move Type:</strong> {this.state.secondStepState.packingOption.label}</p>
            <p className="packing-option"><strong>Move price:</strong>  <span className='your-price'>{this.state.datePackingPrice !== 'TBD' ? this.state.datePackingPrice : 'TBD'} AED</span>, <i>5% VAT included</i></p>
            <p className={this.state.secondStepState.packingOption.value === '5' ? "packing-option" : "hidden"}><strong>Storage price:</strong> <span className='your-price'>{Math.round(this.state.storagePrice).toFixed(2)}د.إ </span> for {this.state.secondStepState.storageDuration.label}, <i>5% VAT included</i></p>

            {this.state.datePackingPrice !== 'TBD' && this.state.secondStepState.packingOption.value !== '5' ?
              <div className='pack-third'>
                {Object.keys(secondStepConstanst['packaging']).map(option =>
                  <div className={this.state.secondStepState.packingOption.label === secondStepConstanst['packaging'][option]['name'] ? 'selected-pack pack-wrap-third' : 'pack-wrap-third'}>
                    <div className='pack-type-third'>
                      <p key={secondStepConstanst['packaging'][option]['type']}>{secondStepConstanst['packaging'][option]['name']}: </p>
                      <p>{(selectedDay > 4 || selectedDay == 0) ? (Object.values(datePrices)[secondStepConstanst['packaging'][option]['type'] - 1] * 1.05).toFixed(2) : Object.values(datePrices)[secondStepConstanst['packaging'][option]['type'] - 1]}د.إ</p>
                    </div>
                    <button value="CHANGE" name={secondStepConstanst['packaging'][option]['name']} id={secondStepConstanst['packaging'][option]['type']} className="change-pt-third"
                      onClick={(event) => {
                        this.changePackingOption(event, this.state.packaging, this.state.packingValue, this.state.datePackingPrice);
                      }}
                      style={this.state.secondStepState.packingOption.label === secondStepConstanst['packaging'][option]['name'] ? { display: 'none' } : { display: 'block' }}>
                      Change
                    </button>
                    <span className="qc-picked-option" style={this.state.secondStepState.packingOption.label === secondStepConstanst['packaging'][option]['name'] ? { display: 'block' } : { display: 'none' }}>
                      Selected</span>
                  </div>
                )
                }
              </div> : null}

            <p className={this.state.distance > 300 ? "over-150" : "hidden"}>Onsite consultation appointment is required for moves above 300 km in distance.</p>
          </div>
          <div>
            <div className='md-customer-info'>
              <h3 className="md-center">Tell us about you:</h3>
              <div className='customer-info-inner'>
                <div className="md-moving-full-2">
                  <input type="text" id="yourName" name="yourName" placeholder="First Name"
                    defaultValue={this.state.yourName.value}
                    className={!this.state.yourName.isFieldValid ? this.state.errorclass : "untouched"}
                    onChange={this.onInputFieldChange} />
                </div>
                <div className="md-moving-full-2">
                  <input type="text" id="yourLastName" name="yourLastName" placeholder="Last Name"
                    defaultValue={this.state.yourLastName.value}
                    className={!this.state.yourLastName.isFieldValid ? this.state.errorclass : "untouched"}
                    onChange={this.onInputFieldChange} />
                </div>

                <div className="md-moving-full-2">
                  <input type="text" id="yourEmail" name="yourEmail" placeholder="Email"
                    defaultValue={this.state.yourEmail.value}
                    className={!this.state.yourEmail.isFieldValid ? this.state.errorclass : "untouched"}
                    onChange={this.onInputFieldChange} />
                </div>
                <div className="md-moving-full-2">
                  <InputMask type="text" id="yourPhone" name="yourPhone" placeholder="Phone"
                    mask="(999) 999-9999"
                    maskChar=" "
                    defaultValue={this.state.yourPhone.value}
                    value={this.state.yourPhone.value}
                    className={!this.state.yourPhone.isFieldValid ? this.state.errorclass : "untouched"}
                    onChange={this.onInputFieldChange} />
                </div>
              </div>
            </div>

            <div className='steps-navigation btn-x-2'>
              <div className="vm-prev-btn">
                <Button type='submit' onClick={this.handleBack}>Previous</Button>
              </div>
              <div className="sec-next-btn">
                <img alt="spinner" style={{ display: 'none' }} id="submit-loading" src="/wp-content/plugins/quote-calculator-r/assets/img/spin-submit.svg" />
                <Button type='submit' onClick={this.handleSubmit}>Submit</Button>
              </div>
            </div>
            <p className="step3-last-text">A copy of this form will go to the e-mail provided. It is also where we will send your move quote. Be sure to check your junk mail if you don’t see it in your inbox.</p>
          </div>
        </div>

        {this.state.datePackingPrice !== 'TBD' &&
          <div className="alternative-dates">
            <div className='alternative-dates-text'>Flexible date? Check out more affordable options.</div>
            <div className="alternative-dates-inner">
              {
                Object.entries(this.state.prices).map(date =>
                  <div className={this.state.firstStepState.movingDate === date[0] ? 'selected-date qc-date' : 'not-selected qc-date'}>
                    <span className="qc-suggested-date">{date[0]} <br /></span>
                    <span className="qc-suggested-day">{days[moment(date[0]).day()]} <br /></span>
                    {
                      discountDays.includes(days[moment(date[0]).day()]) ?
                        <span className="qc-suggested-price">{date[1][this.state.secondStepState.packingOption.value] === "TBD" ? "TBD" : ((date[1][this.state.secondStepState.packingOption.value] * 1.05)).toFixed(2)}د.إ<br /></span>
                        : <span className="qc-suggested-price">{date[1][this.state.secondStepState.packingOption.value] === "TBD" ? "TBD" : (date[1][this.state.secondStepState.packingOption.value]).toFixed(2)}د.إ<br /></span>
                    }
                    <button value="CHANGE"
                      onClick={(event) => {
                        this.changeDate(date[0], event, this.state.datePackingPrice, this.state.basicPrice);
                      }}
                      style={this.state.firstStepState.movingDate === date[0] ? { display: 'none' } : { display: 'block' }}>
                      Select
                    </button>
                    <span className="qc-picked-option" style={this.state.firstStepState.movingDate === date[0] ? { display: 'block' } : { display: 'none' }}>
                      Selected</span>
                  </div>

                )}
            </div>
          </div>}
      </div>
    );
  }
}

export default ThirdStep;



// WEBPACK FOOTER //
// ./src/steps/ThirdStep.js